import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { environment } from '@env/environment';
import { AuthService } from '@shared/auth/auth.service';
import { SharedService } from '@shared/services/shared.service';
import { ISelectItems } from 'app/models/shared/shared';
import { MainMenuService } from 'app/services/mainMenu/mainMenu.service';
import { UserService } from 'app/services/user/user.service';
import { ExemptBusinessListComponent } from './exemptBusinessList/exemptBusinessList.component';
import { BusinessService } from 'app/services/business/business.service';
import { PublicComplaintService } from 'app/services/complaint/public-complaint.service';

@Component({
  selector: 'app-mainMenu',
  templateUrl: './mainMenu.component.html',
  styleUrls: ['./mainMenu.component.scss']
})

export class MainMenuComponent implements OnInit {
  defaultRoute: string = 'mainMenu';

  loggingIn: boolean = false;

  helpUrl: string = environment.wemsHelpLink;
  countySelected: string = 'All';
  countyList: ISelectItems[] = [];
  actionItems: string = '';
  isAdmin: boolean = false;
  newUser: boolean = false;
  updatedRoles: boolean = false;
  // gradients: string[] = [
  //   "#F2F9FD", "#E6F3FC", "#DAEDFB", "#CEE7FA", "#C2E1F9", "#B6DBF8", "#AAD5F7", "#9ECFF6", "#92C9F5",
  //   "#86C3F4", "#7ABDF3", "#6EB7F2", "#62B1F1", "#56ABF0", "#4AA5EF", "#3E9FEE", "#3299ED", "#2693EC", "#1A8DEB"
  // ];

  unverifiedCount: number = 0;
  complaintResponseCount: number = 0;
  businessResponseCount: number = 0;
  siteVisitCount: number = 0;
  followupVisitCount: number = 0;
  postRemediationCount: number = 0;
  citationsCount: number = 0;
  annualInspectionsCount: number = 0;
  businessEnclosedCount: number = 0;

  constructor(
    private sharedService: SharedService,
    public mainMenu: MainMenuService,
    private businessService: BusinessService,
    public publicComplaintService: PublicComplaintService,
    private authService: AuthService,
    private modalService: MatDialog

  ) { }

  ngOnInit(): void {
    this.authService.rolesChanged$.subscribe(
      () => {
        this.updatedRoles = true;
        this.getCountyList();
      }
    );

    this.getCountyList();
    this.countyList = this.sharedService.userCountyList;
  }

  getListsData(countyId: string) {

    this.mainMenu.getComplaints(this.countySelected).subscribe({
      next: response => {
        this.mainMenu.unverifiedList = response;
        this.unverifiedCount = response.length;
      },
      error: e => {
        this.sharedService.toastr.error("Could not get Complaints");
      },
    });

    // complaint Response Letters Due
    this.mainMenu.getResponseLetters(this.countySelected).subscribe({
      next: response => {
        this.mainMenu.complaintResponseList = response;
        this.complaintResponseCount = response.length;
      },
      error: e => {
        this.sharedService.toastr.error("Could not get uresponse letters.");
      },
    });

    // Initial Business Response Letters
    this.mainMenu.getInitialResponseLetters(this.countySelected).subscribe({
      next: response => {
        this.mainMenu.businessResponseList = response;
        this.businessResponseCount = response.length;
      },
      error: e => {
        this.sharedService.toastr.error("Could not get business response.");
      },
    });

    // Site Visit
    this.mainMenu.getSiteVisits(this.countySelected).subscribe({
      next: response => {
        this.mainMenu.siteVisitList = response;
        this.siteVisitCount = response.length;
      },
      error: e => {
        this.sharedService.toastr.error("Could not get Site Visits");
      },
    });

    // Followup Visit
    this.mainMenu.getRemediation(this.countySelected).subscribe({
      next: response => {
        this.mainMenu.followupVisitList = response;
        this.followupVisitCount = response.length;
      },
      error: e => {
        this.sharedService.toastr.error("Could not get followups");
      },
    });

    // Post Remediation
    this.mainMenu.getPostRemediationPlanVisit(this.countySelected).subscribe({
      next: response => {
        this.mainMenu.postRemediationList = response;
        this.postRemediationCount = response.length;
      },
      error: e => {
        this.sharedService.toastr.error("Could not get Post Remediations");
      },
    });

    // Citations
    this.mainMenu.getCitations(this.countySelected).subscribe({
      next: response => {
        this.mainMenu.citationsList = response;
        this.citationsCount = response.length;
      },
      error: e => {
        this.sharedService.toastr.error("Could not get Citations");
      },
    });

    // Annual Inspections
    this.mainMenu.getExemptInspections(this.countySelected).subscribe({
      next: response => {
        this.mainMenu.annualInspectionsList = response;
        this.annualInspectionsCount = response.length;
      },
      error: e => {
        this.sharedService.toastr.error("Could not get Annual Inspections");
      },
    });

    // Business Enclosed
    this.mainMenu.getEnclosedAreas(this.countySelected).subscribe({
      next: response => {
        this.mainMenu.businessEnclosedList = response;
        this.businessEnclosedCount = response.length;
      },
      error: e => {
        this.sharedService.toastr.error("Could not get Business Enclosed");
      },
    });

  }

  getCountyList() {
    this.newUser = false;
    this.sharedService.userCountyList = [];
    if (this.authService.userHasAtLeastOneRole(['Admin', 'Dev'])) {
      this.isAdmin = true;
      this.countyList = this.sharedService.countyDropDownList;
      this.sharedService.userCountyList = this.countyList;
      this.getListsData(this.countySelected);
    }
    else if (this.authService.userHasAtLeastOneRole(['User'])) {
      this.mainMenu.getCountyList().subscribe({
        next: response => {
          
          this.sharedService.setUserCountyList(response);
          this.countyList = this.sharedService.userCountyList;
          let select = this.countyList[0];
          if (this.countySelected == 'All') {
            this.countySelected = select.value;
          }
          this.getListsData(this.countySelected);
        },
        error: e => {
          console.log('Could not get county list.');
        },
      });
    }
    else {
      this.newUser = true && this.updatedRoles;
    }
  }


  unverified(countyId: string) {
    this.actionItems = this.actionItems == 'unverified' ? '' : 'unverified';
  }

  complaintResponse(countyId: string) {
    this.actionItems = this.actionItems == 'complaintResponse' ? '' : 'complaintResponse';
  }

  businessResponse(countyId: string) {
    this.actionItems = this.actionItems == 'businessResponse' ? '' : 'businessResponse';
  }

  siteVisit(countyId: string) {
    this.actionItems = this.actionItems == 'siteVisit' ? '' : 'siteVisit';
  }

  followupVisit(countyId: string) {
    this.actionItems = this.actionItems == 'followupVisit' ? '' : 'followupVisit';
  }

  postRemediation(countyId: string) {
    this.actionItems = this.actionItems == 'postRemediation' ? '' : 'postRemediation';
  }

  citations(countyId: string) {
    this.actionItems = this.actionItems == 'citations' ? '' : 'citations';
  }

  annualInspections(countyId: string) {
    this.actionItems = this.actionItems == 'annualInspections' ? '' : 'annualInspections';
  }

  businessEnclosed(countyId: string) {
    this.actionItems = this.actionItems == 'businessEnclosed' ? '' : 'businessEnclosed';
  }

  // rowClick(row: any) {

  // }

  showExemptBusinesses() {
    let config = new MatDialogConfig<any>();
    config.autoFocus = true;
    config.disableClose = false;
    config.minWidth = 600;
    config.maxHeight = 600;
    config.data = {

    };
    const dialogRef = this.modalService.open(ExemptBusinessListComponent, config);
    dialogRef.afterClosed().subscribe(
      data => {
        if (data > 0) {
          this.gotoBusiness(data);
        }
      },
      error => this.sharedService.toastr.error("Could not preview Correspondence"),
      () => { }
    );
  }

  countyChange(countyId: string) {
    this.actionItems = '';
    this.getListsData(countyId);
  }

  gotoBusiness(businessId: number) {
    this.businessService.businessId = businessId;
    this.businessService.businessTab = 0;
    this.sharedService.doRedirect('business/business');
  }


  helpFile(): void {
    this.sharedService.doRedirect('mainMenu/help');
    // this.publicComplaintService.downloadHelpFile().subscribe(
    //   response => this.downloadFile("Help", response),
    //   error => console.log('error', error)
    // );
  }

  downloadFile(fileName: string, blob: Blob) {
    let file = URL.createObjectURL(blob);
    var fileDownload = document.createElement('a');
    fileDownload.href = file;
    fileDownload.download = fileName;
    fileDownload.click();
  }
}